import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    component: () => import("@/pages/index.vue"),
    meta: { header: true }
  },
  {
    path: "/pages",
    component: () => import("@/pages/pages/index.vue"),
    async beforeEnter(to, from, next) {
      await store.dispatch("page/fetchAll");
      next();
    },
    meta: { header: true }
  },
  {
    path: "/pages/:id",
    component: () => import("@/pages/pages/_id.vue"),
    async beforeEnter(to, from, next) {
      await store.dispatch("page/fetchAll");
      next();
    }
  },
  {
    path: "/s/:id",
    component: () => import("@/pages/s/_id.vue"),
    async beforeEnter(to, from, next) {
      console.log(to.params.id);
      try {
        await store.dispatch("page/fetchDynamic", to.params.id);
        next();
      } catch (error) {
        next({
          params: { message: "Page not found", code: "404" },
          path: "/error"
        });
      }
    },
    meta: { header: true }
  },
  {
    path: "/error",
    component: () => import("@/pages/error.vue"),
    props: true
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
